import { NotificationTab } from '@notifications/enums/notification-tab.enum';
import { StoreNotification } from '@notifications/models/store-notification';

export class NotificationsState {
    public readonly isShowOnlyUnviewedNotifications: boolean = true;
    public readonly notifications: StoreNotification[] = [];
    public readonly appointmentsVisualizationAllowed: boolean = true;
    public readonly activeTab: NotificationTab = NotificationTab.All;
}